<template>
  <div
    :class="{
      'project-date-empty': importantEvents.length === 0,
      empty: importantEvents.length === 0,
    }"
  >
    <div class="project-date-header header">
      <h4 class="text-danger">
        Deadlines ({{ importantEvents.length }})
        <button
          class="btn"
          @click="toggleList = !toggleList"
          :class="{ active: !toggleList }"
        >
          <i class="fas fa-chevron-down"></i>
        </button>
      </h4>
    </div>
    <div v-if="toggleList" class="project-date-list">
      <div v-if="importantEvents.length === 0">
        <i class="empty-state far fa-sticky-note"></i>
        <span class="empty-search">Brak ważnych dat</span>
      </div>
      <div v-else>
        <div
          :class="{
            'project-date': true,
            'project-date--outofdate': isOutOfDate(importantEvents.date),
          }"
          v-for="(importantEvents, index) in importantEvents"
          :key="index"
        >
          <div class="project-date-content">
            <span>{{ importantEvents.date }}</span>
            <p>{{ importantEvents.label }}</p>
          </div>
          <b-dropdown
            no-caret
            right
            variant="light"
            class="btn-rounded"
            v-if="showOptions(importantEvents)"
          >
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item-button @click="showModal(index)"
              >Edytuj</b-dropdown-item-button
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button class="danger" @click="remove(index)">
              <i class="fas fa-trash-alt"></i> Usuń
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </div>
    </div>
    <ImportantEventsModalForm
      :eventdate="selected"
      :eventIndex="selectedIndex"
      v-on:onUpdate="onUpdate"
      v-on:onClose="clean"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ImportantEventsModalForm from "@/components/notes/ImportantEventsModalForm";

export default {
  name: "ImportantEventsPortlet",
  components: { ImportantEventsModalForm },
  data() {
    return {
      selectedIndex: -1,
      selected: {},
      toggleList: true,
    };
  },
  computed: {
    ...mapGetters("user", ["getRole"]),
    ...mapGetters("construction", ["importantEvents"]),
  },
  methods: {
    ...mapActions("construction", ["importantEventsUpate"]),
    remove(importantDatesIndex) {
      this.clean();
      if (!(importantDatesIndex >= 0)) return;
      let importantEventToDelete = this.importantEvents[importantDatesIndex],
        h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy na pewno chcesz usunąć ważną datę ",
              h("br"),
              h("br"),
              h(
                "strong",
                importantEventToDelete.date +
                  " : " +
                  importantEventToDelete.label
              ),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie ważnej daty",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result === true) {
            let newEvents = this.cloneEvents();
            newEvents.splice(importantDatesIndex, 1);
            this.$Progress.start();
            this.importantEventsUpate(newEvents);
          }
        });
    },
    showModal(importantDatesIndex) {
      if (importantDatesIndex >= 0) {
        this.selected = this.importantEvents[importantDatesIndex];
        this.selectedIndex = importantDatesIndex;
      }
      this.$nextTick(() => {
        this.$bvModal.show("datesForm-modal");
      });
    },
    onUpdate(newEvent) {
      if (!(this.selectedIndex >= 0)) return;
      //Przygotowanie tablicy
      let newEvents = this.cloneEvents();
      newEvents[this.selectedIndex] = {
        date: newEvent.date,
        label: newEvent.label,
      };
      this.$Progress.start();
      this.importantEventsUpate(newEvents).then(() => {
        this.$nextTick(() => {
          this.$bvModal.hide("datesForm-modal");
        });
      });
    },
    clean() {
      this.selected = {};
      this.selectedIndex = -1;
    },
    showOptions(importantEvents) {
      if (this.isOutOfDate(importantEvents.date)) return false;
      if (
        this.getRole !== "subcontractor" &&
        this.getRole !== "employee_simple"
      )
        return true;
      return false;
    },
    isOutOfDate(dateString) {
      let chcekDate = new Date(dateString + " 23:59:59");
      let today = new Date();
      return today.getTime() > chcekDate.getTime();
    },
    cloneEvents() {
      let newEvents = [];
      this.importantEvents.forEach((element) => {
        newEvents.push({
          date: element.date,
          label: element.label,
        });
      });
      return newEvents;
    },
  },
};
</script>
